module.exports = __webpack_public_path__ + "static/img/car_new_mg_extenderdc.05dfbbe7.png";